const sendUserTiming = function (timingName: string): void {
  if (!(window.performance && window.performance.measure)) return;

  const entries = window.performance.getEntriesByName(timingName, 'measure');
  if (entries.length !== 1) return;

  const timingValue = Math.round(entries[0].duration);

  typeof gtag === 'function' &&
    gtag('event', 'timing_complete', {
      name: timingName,
      value: timingValue,
      event_category: 'User-centric',
    });
};
sendUserTiming('Time To First Byte');

export default sendUserTiming;
